module.exports = {
  src: __webpack_public_path__ + "static/media/commercial_00021.30131798.jpg",
  width: 4992,
  height: 3328,
  bytes: 1091317,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/commercial_00021.30131798.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/commercial/commercial_00021.jpg
// module id = 271
// module chunks = 0